<template>
<div class="chapter">
<div class="inner_page">
<div class="book" title="Pie Pops">
<div class="frontmatter">
<div class="recto">
<h1 class="title"><a id="index"></a>Pie Pops</h1>
<h3 class="author">Marcie Ballard</h3>
<h4>Photographs by Susan Hayward</h4>
<img alt="Gibbs Smith Logo" src="images/logo.jpg"/>
</div>
<div class="verso">
<p class="versotitle">Pie Pops</p>
<p>Digital Edition 1.0</p>
<p class="copyright">Text © 2013 Marcie Ballard</p>
<p>Photographs © 2013 Susan Hayward</p>
<p>All rights reserved. No part of this book may be reproduced by any means whatsoever
            without written permission from the publisher, except brief portions quoted for purpose
            of review.</p>
<p class="nobreak">Gibbs Smith</p>
<p class="nobreak">P.O. Box 667</p>
<p>Layton, Utah 84041</p>
<p class="nobreak">Orders: 1.800.835.4993</p>
<p>www.gibbs-smith.com</p>
<p>ISBN: 978-1-4236-3120-0</p>
</div>
</div>
<div class="frontmatter">
<div class="dedication" title="Dedication">
<p>To the amazing women in my life, who taught me if you work hard you can have your pie
            and eat it too. </p>
<p>To the wonderful men in my life, who keep me smiling and giggling, especially when I
            have food in my teeth.</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?d2ff4ca4